/**
 * Application-wide configuration constants.
 */

// Idle timeout: total time before the session expires due to inactivity
export const IDLE_TIMEOUT_MS = 5 * 60 * 1000; // 5 minutes

// Warning shown before session expires
export const IDLE_WARNING_MS = 4 * 60 * 1000; // 4 minutes (1 minute warning)
